/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionOutcomeDto
 */
export interface ExecutionOutcomeDto {
    /**
     * The id of the outcome, aka action
     * @type {string}
     * @memberof ExecutionOutcomeDto
     */
    id?: string;
    /**
     * The executed action
     * @type {string}
     * @memberof ExecutionOutcomeDto
     * @deprecated
     */
    actionInfo?: string;
    /**
     * The executed action type
     * @type {string}
     * @memberof ExecutionOutcomeDto
     */
    actionType?: string;
    /**
     * The state of the execution for the given action
     * @type {string}
     * @memberof ExecutionOutcomeDto
     */
    executionState?: ExecutionOutcomeDtoExecutionStateEnum;
    /**
     * The contract ids associated with this outcome
     * @type {Array<number>}
     * @memberof ExecutionOutcomeDto
     */
    contractIds?: Array<number>;
    /**
     * The receivable ids associated with this outcome
     * @type {Array<number>}
     * @memberof ExecutionOutcomeDto
     */
    receivableIds?: Array<number>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ExecutionOutcomeDto
     */
    properties?: { [key: string]: object; };
    /**
     * Last time the outcome was retried
     * @type {Date}
     * @memberof ExecutionOutcomeDto
     */
    lastModified?: Date;
    /**
     * Last user who retried the outcome
     * @type {string}
     * @memberof ExecutionOutcomeDto
     */
    lastModifiedUser?: string;
    /**
     * The name of the rule used in the execution outcome
     * @type {string}
     * @memberof ExecutionOutcomeDto
     */
    ruleName?: string;
}


/**
 * @export
 */
export const ExecutionOutcomeDtoExecutionStateEnum = {
    Pending: 'PENDING',
    AwaitingSiblings: 'AWAITING_SIBLINGS',
    Successful: 'SUCCESSFUL',
    Failed: 'FAILED',
    Retry: 'RETRY',
    Canceled: 'CANCELED',
    Rejected: 'REJECTED'
} as const;
export type ExecutionOutcomeDtoExecutionStateEnum = typeof ExecutionOutcomeDtoExecutionStateEnum[keyof typeof ExecutionOutcomeDtoExecutionStateEnum];


/**
 * Check if a given object implements the ExecutionOutcomeDto interface.
 */
export function instanceOfExecutionOutcomeDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecutionOutcomeDtoFromJSON(json: any): ExecutionOutcomeDto {
    return ExecutionOutcomeDtoFromJSONTyped(json, false);
}

export function ExecutionOutcomeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionOutcomeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'actionInfo': !exists(json, 'actionInfo') ? undefined : json['actionInfo'],
        'actionType': !exists(json, 'actionType') ? undefined : json['actionType'],
        'executionState': !exists(json, 'executionState') ? undefined : json['executionState'],
        'contractIds': !exists(json, 'contractIds') ? undefined : json['contractIds'],
        'receivableIds': !exists(json, 'receivableIds') ? undefined : json['receivableIds'],
        'properties': !exists(json, 'properties') ? undefined : json['properties'],
        'lastModified': !exists(json, 'lastModified') ? undefined : (new Date(json['lastModified'])),
        'lastModifiedUser': !exists(json, 'lastModifiedUser') ? undefined : json['lastModifiedUser'],
        'ruleName': !exists(json, 'ruleName') ? undefined : json['ruleName'],
    };
}

export function ExecutionOutcomeDtoToJSON(value?: ExecutionOutcomeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'actionInfo': value.actionInfo,
        'actionType': value.actionType,
        'executionState': value.executionState,
        'contractIds': value.contractIds,
        'receivableIds': value.receivableIds,
        'properties': value.properties,
        'lastModified': value.lastModified === undefined ? undefined : (value.lastModified.toISOString()),
        'lastModifiedUser': value.lastModifiedUser,
        'ruleName': value.ruleName,
    };
}

